module.exports = __webpack_public_path__ + "img/slider_multi1.f4e14a6b.jpeg";